/**
 * @generated SignedSource<<70c3440a202cfdad1b4e531c7435152b>>
 * @relayHash ebd0cfdc3b09a8f2dd0b3e7d12e0b64d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 26f590dcda44b5fc757b038bb24223ad14175c339c87b80b056b42ed91aa2a99

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type uiFeatureFlagsEmptyStateExperienceQuery$variables = {
  projectAri: string;
};
export type uiFeatureFlagsEmptyStateExperienceQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareEmptyStateExperienceFeatureFlags_FeatureFlagsEmptyStateExperience_query">;
};
export type uiFeatureFlagsEmptyStateExperienceQuery = {
  response: uiFeatureFlagsEmptyStateExperienceQuery$data;
  variables: uiFeatureFlagsEmptyStateExperienceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectAri"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "uiFeatureFlagsEmptyStateExperienceQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "ui_softwareEmptyStateExperienceFeatureFlags_FeatureFlagsEmptyStateExperience_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "uiFeatureFlagsEmptyStateExperienceQuery",
    "selections": [
      {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "concreteType": "AriGraph",
            "kind": "LinkedField",
            "name": "ariGraph",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "from",
                        "variableName": "projectAri"
                      },
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "project-associated-feature-flag"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  }
                ],
                "concreteType": "AriGraphRelationshipConnection",
                "kind": "LinkedField",
                "name": "relationships",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "AriGraphRelationship",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "26f590dcda44b5fc757b038bb24223ad14175c339c87b80b056b42ed91aa2a99",
    "metadata": {},
    "name": "uiFeatureFlagsEmptyStateExperienceQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c8856730dcfda88439b157a25ff3f97f";

export default node;
